import { render, staticRenderFns } from "./equipmentMallDetail.vue?vue&type=template&id=2d76fb34&scoped=true"
import script from "./equipmentMallDetail.vue?vue&type=script&lang=js"
export * from "./equipmentMallDetail.vue?vue&type=script&lang=js"
import style0 from "./equipmentMallDetail.vue?vue&type=style&index=0&id=2d76fb34&prod&lang=scss&scoped=true"
import style1 from "./equipmentMallDetail.vue?vue&type=style&index=1&id=2d76fb34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d76fb34",
  null
  
)

export default component.exports